import _ from "lodash";
import {getArrayFromObjectArray} from "_helpers";
import {metaActions} from "_actions";

export function processFbFeed(dispatch, conversation, message) {
    let { msgDataSource, text } = message;
    const msgDataSourceId = _.get(msgDataSource, 'id');

    const conversationTexts = getArrayFromObjectArray(conversation, 'text');
    const textArr = [...new Set([text, ...conversationTexts].filter(Boolean))];

    const mediaItems = textArr
        .map(extractMedia)
        .filter(Boolean);

    const mediaItemsGroup = _.groupBy(mediaItems, 'type');

    if (mediaItemsGroup.PHOTO?.length > 0) {
        const photoIds = mediaItemsGroup.PHOTO.map(item => item.id);
        const params = buildGetPhotosParams(photoIds, msgDataSourceId);
        dispatch(metaActions.getFbPhotos(params));
    }

    if (mediaItemsGroup.VIDEO?.length > 0) {
        const videoIds = mediaItemsGroup.VIDEO.map(item => item.id);
        const params = buildGetVideosParams(videoIds, msgDataSourceId);
        dispatch(metaActions.getFbVideos(params));
    }
}

export function extractMedia(text) {
    const match = text?.match(/\[(PHOTO_ID|GIF_ID|VIDEO_ID):\s*(\w+)\]/);
    if (!match) return null;

    return {
        type: match[1].replace('_ID', ''),
        id: match[2]
    };
}

function buildGetPhotosParams(photoIds, msgDataSourceId) {
    return {
        ids: photoIds.join(','),
        type: 'photo',
        msgDataSource: msgDataSourceId
    };
}

function buildGetVideosParams(videoIds, msgDataSourceId) {
    return {
        ids: videoIds.join(','),
        type: 'video',
        msgDataSource: msgDataSourceId
    };
}

export const metaMediaType = {
    GIF: 'GIF',
    PHOTO: 'PHOTO',
    VIDEO: 'VIDEO',
};
